<template>
  <g>
    <g clip-path="url(#clip0_15_281)">
      <path
        d="M10.06 5.00022H5.82L6.48 1.82021C6.56 1.45021 6.44 1.07021 6.18 0.800215C5.74 0.360215 5.03 0.360215 4.6 0.800215L0.6 4.80022C0.21 5.17022 0 5.68021 0 6.21022V12.0002C0 13.1002 0.9 14.0002 2 14.0002H7.92C8.72 14.0002 9.44 13.5202 9.76 12.7902L11.9 7.79022C12.46 6.47021 11.49 5.00022 10.06 5.00022ZM22 10.0002H16.08C15.28 10.0002 14.56 10.4802 14.24 11.2102L12.1 16.2102C11.54 17.5302 12.5 19.0002 13.94 19.0002H18.18L17.52 22.1802C17.44 22.5502 17.56 22.9302 17.82 23.2002C18.26 23.6402 18.97 23.6402 19.4 23.2002L23.4 19.2002C23.78 18.8202 23.99 18.3202 23.99 17.7902V12.0002C24 10.9002 23.1 10.0002 22 10.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_281">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
